// @mui icons
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import MusicNoteIcon from "@mui/icons-material/MusicNote"; // TikTok için placeholder

// Lex Go components
import MKTypography from "components/MKTypography";

// Images
import logoLexGo from "assets/images/logo-ct-dark.png";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "LexGo",
    image: logoLexGo,
    route: "/",
  },
  socials: [
    {
      icon: <InstagramIcon />,
      link: "https://www.instagram.com/lexgo.hukuk/",
    },
    {
      icon: <MusicNoteIcon />,
      link: "https://www.tiktok.com/@lexgo04/photo/7545211263148690696?_t=ZS-8zpun7l3BB4&_r=1",
    },
    {
      icon: <LinkedInIcon />,
      link: "https://www.linkedin.com/in/lexgo-hukuk-829900381/",
    },
    {
      icon: <TwitterIcon />,
      link: "https://x.com/LexgoHukuk",
    },
  ],
  menus: [
    {
      name: "Hizmetler",
      items: [
        { name: "Ücretsiz Şablonlar", href: "/hizmetler/ucretsiz/kira" },
        { name: "Premium Paketler", href: "/hizmetler/premium/girisimci" },
      ],
    },
    {
      name: "Rehberler & Blog",
      items: [
        { name: "Hukuki Bilgiler", href: "/rehberler/hukuki-bilgiler" },
        { name: "Yargıtay Kararları Özeti", href: "/rehberler/yargitay-ozetleri" },
        { name: "Start-up Hukuku Notları", href: "/rehberler/startup-hukuku" },
      ],
    },
    {
      name: "Hakkımızda",
      items: [
        { name: "Misyonumuz", href: "/hakkimizda/misyon" },
        { name: "Neden LexGo?", href: "/hakkimizda/neden-lexgo" },
      ],
    },
    {
      name: "İletişim",
      items: [
        { name: "İletişim Formu", href: "/iletisim/form" },
        { name: "WhatsApp Hızlı Erişim", href: "/iletisim/whatsapp" },
        { name: "Sosyal Medya & Abonelik", href: "/iletisim/abonelik" },
      ],
    },
    {
      name: "Yasal",
      items: [
        { name: "Kullanım Koşulları", href: "/legal/terms" },
        { name: "Gizlilik Politikası", href: "/legal/privacy" },
        { name: "KVKK Aydınlatma", href: "/legal/kvkk" },
      ],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      © {date}{" "}
      <MKTypography component="a" href="/" variant="button" fontWeight="regular">
        LexGo
      </MKTypography>
      . Tüm hakları saklıdır.
    </MKTypography>
  ),
};
